import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function useWinLossByDay(filters: AnalyticsFilters = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ANALYTICS_QUERY_KEY, "win-loss-by-day", filters],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/analytics/win-loss-by-day", {
        params: { query: toAnalyticsQuery(filters) },
      });
      if (error !== undefined) {
        throw new Error("Failed to load daily wins/losses");
      }
      return data;
    },
  });
}
